import tw, { styled } from 'twin.macro';
import Button from './Button';

export default styled(Button)`
  ${tw`w-full`}
  [data-content-type=buttonTextSpan] {
    display: initial;
    align-items: initial;
    justify-center: initial;
    width: initial;
    ${tw`truncate`}
  }
`;
